export const EmploymentStatusEnum = {
    Active: 1,
    Terminated: 2,
    Pending: 3
};
